const state = {
  isLrLoading: false,
  list: [],
  certifications: {
    fssai: {
      attachment_id: '',
      attachment_url: '',
      number: '',
      expiry_date: '',
    },
    tds: {
      attachment_id: '',
      attachment_url: '',
      number: '',
      expiry_date: '',
    } },
  isUploading: false,
  isLoading: false,
  centralHo:[],
  permissionList: [],
  rolePermissions: [],
};

export default state;
